<p-toast></p-toast>

<p-sidebar [(visible)]="visible" position="right"
           (onHide)="cancel()"
           [style]="{width:'635px'}">
    <ng-template pTemplate="header"><div class="business-info-update-header">Edit Business info</div></ng-template>

    <div *ngIf="loading" style="text-align: center;">
        <p-progressSpinner [style]="{width: '50px', height: '50px'}" styleClass="custom-spinner" strokeWidth="5" fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
    </div>

    <div class="business-info-update-body">
        <div class="business-info-update-input-item">
            <div class="flex flex-row" style="align-items: baseline;">
                <div class="business-info-update-input-title">Registered company name</div>
                <div class="business-info-update-input-title-min">(same as SEC document)</div>
            </div>
            <input [(ngModel)]="businessInfo.businessName" placeholder="Registered company name" type="text" pInputText />
        </div>

        <div class="business-info-update-input-item">
            <div class="flex flex-row" style="align-items: baseline;">
                <div class="business-info-update-input-title">Registered company address</div>
                <div class="business-info-update-input-title-min">(same as SEC document)</div>
            </div>
            <input [(ngModel)]="businessInfo.address" placeholder="Search in Google Maps" type="text" pInputText />
            <div class="flex flex-row" style="margin-top: 25px;">
                <input [(ngModel)]="businessInfo.city" placeholder="City" type="text" pInputText />
                <input [(ngModel)]="businessInfo.postalCode" placeholder="Postal Code" type="text" pInputText style="margin-left: 40px;" />
            </div>
        </div>

        <div class="business-info-update-input-item">
            <div class="flex flex-row" style="align-items: baseline;">
                <div class="business-info-update-input-title">Trading name</div>
                <div class="business-info-update-input-title-min">(what will be published in app)</div>
            </div>
            <input [(ngModel)]="businessInfo.name" placeholder="Trading Name" type="text" pInputText />
        </div>

        <div class="flex flex-row">
            <div style="width: 100%">
                <div class="business-info-update-input-title">Company phone</div>
                <input [(ngModel)]="businessInfo.phone" placeholder="Phone" type="tel" pInputText />
            </div>
            <div style="margin-left: 40px; width: 100%">
                <div class="business-info-update-input-title">Company Email</div>
                <input [(ngModel)]="businessInfo.email" placeholder="Email" type="email" pInputText />
            </div>
        </div>

    </div>
    <div class="flex justify-content-end mrg-10-0px">
        <button (click)="updateBusinessInfo()" class="btn-darkblue" pButton label="Confirm" style="width: 91px; height: 45px;"></button>
    </div>

</p-sidebar>

